<div class="auth-wrapper">
	<div class="auth-shell">
		<div class="auth-container">

			<div class="overlay-container">
				<div class="overlay">
					<div class="overlay-panel overlay-right">
						<h1>Acesso Celular</h1>
						<p>Valide e confirme o seu acesso através do link enviado para o seu dispositivo.</p>
					</div>
				</div>
			</div>

			<div class="form-container sign-in-container">
				
				<div *ngIf="isLoading" class="loading-container">
					<mat-spinner [diameter]="48"></mat-spinner>
					<p style="margin-top: 16px; color: var(--text-soft);">Validando link...</p>
				</div>

				<div *ngIf="loginSucesso && !isLoading" class="auth-form">
					<img class="logo" src="assets/img/logo-sistema.png" (click)="redirectToSistemas()" />
					<div class="success-icon" style="color: #4caf50; margin-bottom: 16px;">
						<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
							<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
						</svg>
					</div>
					<h2 style="color: #4caf50; font-size: 24px; font-weight: bold; margin-bottom: 8px;">Sessão Ativada!</h2>
					<div class="info-box" style="background: #e8f5e9; padding: 16px; border-radius: 8px; margin-top: 16px; width: 100%;">
						<p style="color: #2e7d32; font-size: 14px; margin: 0;">✓ Você pode fechar esta janela agora</p>
					</div>
				</div>

				<div *ngIf="hashInvalida && !isLoading" class="auth-form">
					<img class="logo" src="assets/img/logo-sistema.png" (click)="redirectToSistemas()" />
					<div class="error-msg" style="justify-content: center; text-align: center; margin-bottom: 16px; font-size: 14px;">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
							<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
						</svg>
						<span class="txterror">Este link é inválido ou já foi utilizado.</span>
					</div>
					<button class="submit" type="button" (click)="backToHome()">Voltar ao Login</button>
				</div>

				<form *ngIf="!subscription && !isLoading && !hashInvalida && !loginSucesso" class="auth-form" [formGroup]="loginFormGroup">
					<img class="logo" src="assets/img/logo-sistema.png" (click)="redirectToSistemas()" />
					<h2>Confirmação</h2>
					<span class="sub-text">Login via celular: <strong>{{nrCelularMasked}}</strong></span>

					<div *ngIf="errStr" class="error-msg">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
							<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
						</svg>
						<span class="txterror">{{errStr}}</span>
					</div>

					<div class="custom-input-group">
						<input [type]="hidePassword ? 'password' : 'text'" class="custom-input" formControlName="pass" placeholder="Senha" />
						<button class="password-toggle" (click)="togglePasswordVisibility()" type="button" tabindex="-1">
							<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
					</div>

					<button type="submit" class="submit" [disabled]="loginFormGroup.invalid" (click)="onLogin()">
						Entrar
					</button>
					<a class="forgot-link" (click)="backToHome()">Cancelar</a>
				</form>

				<div *ngIf="subscription && !isLoading" class="inline-loading-container">
					<mat-spinner [diameter]="48"></mat-spinner>
				</div>

			</div>

		</div>
	</div>
</div>
